import Button from '@/shared/Button';
import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import Map from '../Map';
import Link from '@/shared/Link';
import ChevronRight from '../Icons/ChevronRight';
import LeftArrowIcon from '../Icons/LeftArrow';
import Image from '@/shared/Image';
import classNames from 'classnames';
import useScreen from '@/hooks/useScreen';
type MulticategoryPrexoContentProps = {
  prexoValues: any[];
  showAllCategories: boolean;
  setShowAllCategories: (val: boolean) => void;
  selectedCategory: number | null;
  setSelectedCategory: (val: number) => void;
  setSelectedState: (val: any) => void;
  PrexoState: any;
};

const MulticategoryPrexoContent: React.FC<MulticategoryPrexoContentProps> = ({
  prexoValues,
  showAllCategories,
  setShowAllCategories,
  selectedCategory,
  setSelectedCategory,
  setSelectedState,
  PrexoState,
}) => {
  const { isDesktop } = useScreen();
  const visiblePrexoValues = isDesktop
    ? prexoValues
    : showAllCategories
    ? prexoValues
    : prexoValues.slice(0, 6);
  const rowIndices = Array.from({ length: Math.ceil(visiblePrexoValues.length / 3) });

  return (
    <Div className="flex flex-col w-full">
      <Div className="flex flex-row items-center gap-s3 mx-s5 mb-s5 md:mb-s7">
        <Paragraph className="text-cti-primary text-h-3 flex md:text-hd-3">
          Select Product Category
        </Paragraph>
      </Div>
      <Div className="flex flex-col gap-s5 px-4 w-full">
        <Map
          list={rowIndices}
          render={(_, rowIdx) => (
            <Div key={rowIdx} className="flex w-full gap-s5 items-stretch">
              <Map
                list={visiblePrexoValues.slice(rowIdx * 3, rowIdx * 3 + 3)}
                render={(prexoItem, idx) => {
                  const itemIdx = rowIdx * 3 + idx;
                  const selectCategory = () => setSelectedCategory(itemIdx);
                  return (
                    <Button
                      theme="none"
                      key={itemIdx}
                      className={classNames(
                        'w-1/3 cursor-pointer rounded-cm flex flex-col justify-between p-s5 gap-s3 border',
                        {
                          'bg-new-gradient border-cu-selected': selectedCategory === itemIdx,
                          'bg-cs-secondary border-transparent': selectedCategory !== itemIdx,
                        },
                      )}
                      onClick={selectCategory}
                    >
                      <Div className="flex flex-col items-center gap-s3 flex-grow">
                        <Div className="">
                          {prexoItem.imageUrl ? (
                            <Image src={prexoItem.imageUrl} alt={prexoItem.categoryName} />
                          ) : null}
                        </Div>
                        <Div className="flex-grow flex ">
                          <Paragraph
                            className={classNames('text-body-base text-center', {
                              'text-callout-small md:text-callout-small':
                                selectedCategory === itemIdx,
                            })}
                          >
                            {prexoItem.categoryName}
                          </Paragraph>
                        </Div>
                      </Div>
                      <Paragraph className="text-body-xs text-cu-positive text-center mt-auto">
                        ₹ {prexoItem.value} OFF
                      </Paragraph>
                    </Button>
                  );
                }}
              />
            </Div>
          )}
        />
      </Div>
      {!isDesktop && prexoValues.length > 6 && (
        <Div className="flex justify-center mt-s5">
          <Link
            href="#"
            className="flex p-s4 py-s4 px-0 justify-center items-center gap-s3 flex-1 text-cu-selected"
            onClick={() => setShowAllCategories(!showAllCategories)}
          >
            {showAllCategories
              ? 'Hide more categories'
              : `View ${prexoValues.length - 6} more categor${
                  prexoValues.length - 6 === 1 ? 'y' : 'ies'
                }`}
            <Div
              className={classNames('transform', {
                '-rotate-90': showAllCategories,
                'rotate-90': !showAllCategories,
              })}
            >
              <ChevronRight />
            </Div>
          </Link>
        </Div>
      )}
    </Div>
  );
};

export default MulticategoryPrexoContent;
